import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import PropTypes from 'prop-types';

const AutocompleteRenderGroup = ({ key, groupTitle, children }) => {
  const theme = useTheme();

  return (
    <li key={key}>
      <Typography
        sx={{
          padding: '4px 10px',
          position: 'sticky',
          top: 0,
          background: theme.palette.background.light,
          color: theme.palette.text.primary,
          fontWeight: 'bold',
        }}
      >
        {groupTitle}
      </Typography>
      <Box component="ul" padding={0}>
        {children}
      </Box>
    </li>
  );
};

AutocompleteRenderGroup.propTypes = {
  key: PropTypes.string.isRequired,
  groupTitle: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default AutocompleteRenderGroup;
